export function shouldRetryApiRequest(failureCount: number, error: unknown): boolean {
  const status = (error as { response?: { status?: number } })?.response?.status;
  return failureCount < 1 && !(status && status >= 400 && status < 500);
}
